import React, { useContext, useState } from "react";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

import FaqModeration from "../FaqModeration";
import Files from "../Files";

import { AuthContext } from "../../context/Auth/AuthContext";
import { hasPermission } from "../../helpers/hasPermission";

// Pedido do usuario 2026-10-08: existiam duas telas de "conhecimento de
// IA" desconectadas - "Base de Conhecimento" (perguntas/respostas
// aprovadas, mas que nunca eram lidas de volta pela IA - ver fix em
// GetApprovedFaqKnowledgeService) e "Lista de Arquivos" (PDFs/DOCX/CSV
// que alimentam de verdade o bot e a Voice), em secoes bem distantes do
// menu. Unifica as duas aqui numa tela so, com abas - cada aba reusa o
// componente original (so' sem o MainContainer/MainHeader proprios, via
// prop "embedded").
const KnowledgeBase = () => {
  const { user } = useContext(AuthContext);
  const canSeeFaqs = hasPermission(user, "menu:faq-moderation");
  const canSeeFiles = hasPermission(user, "menu:files");

  const [tab, setTab] = useState(canSeeFaqs ? 0 : 1);

  return (
    <MainContainer>
      <MainHeader>
        <Title>Base de Conhecimento</Title>
      </MainHeader>
      <Tabs value={tab} onChange={(e, v) => setTab(v)} indicatorColor="primary" textColor="primary">
        {canSeeFaqs && <Tab label="Perguntas e Respostas" value={0} />}
        {canSeeFiles && <Tab label="Arquivos" value={1} />}
      </Tabs>
      {tab === 0 && canSeeFaqs && <FaqModeration embedded />}
      {tab === 1 && canSeeFiles && <Files embedded />}
    </MainContainer>
  );
};

export default KnowledgeBase;
